<div class="add-user">
  <button class="vox-btn vox-btn-secondary" [disabled]="company.readOnly" (click)="openAddUserPopup()"
    translate>company.users.add-button</button>
  <div class="add-user__actions">
    <button *ngIf="showSyncPasswordButton" class="vox-btn vox-btn-secondary-dark-grey" [disabled]="company.readOnly || loading" (click)="syncPasswords()" translate>company.users.sync-passwords.button</button>
    <ng-container>
      <div class="include-users" [ngClass]="{'has-sync-password': showSyncPasswordButton}" *ngIf="!requestFailed && !loadingContactsConfig && showToggle">
        <label class="include-users__info">
          {{'company.users.include-users.title' | translate}}
          <i class="icon-small-info" [placement]="showSyncPasswordButton ? 'left' : 'top'" [ngbTooltip]="tooltip"></i>
          <ng-template #tooltip>
            <span [innerHTML]="'company.users.include-users.tooltip' | translate"></span>
          </ng-template>
        </label>
        <vox-toggle [toggleOn]="includeUsers" [config]="{isAquamarine: true }"  (toggleOnChange)="toggelContactsConfiguration($event)"></vox-toggle>
      </div>
      <button *ngIf="requestFailed && !loadingContactsConfig" (click)="getContactsConfiguration()" container="body" placement="left" [ngbTooltip]="'company.users.include-users.re-try' | translate" class="vox-btn vox-btn-icon btn-update"> <i class="icon-small-update"></i> </button>
      <ngx-skeleton-loader *ngIf="loadingContactsConfig" [theme]="{'margin-bottom': '-7px','height': '48px','width': '180px' }"></ngx-skeleton-loader>
    </ng-container>
  </div>
</div>
<div class="vox-table company-users">
  <table>
    <thead>
      <tr>
        <td>#</td>
        <td translate>company.users.first-name</td>
        <td translate>company.users.last-name</td>
        <td translate>company.users.email</td>
        <td translate>company.users.phone</td>
        <td translate>company.users.extension</td>
        <td translate>company.users.actions</td>
      </tr>
    </thead>
    <tbody *ngIf="!loading">
      <ng-container *ngFor="let u of users; let i = index">
        <tr *ngIf="u._isDeleting" class="user-data-row">
          <td colspan="7">
            <ngx-skeleton-loader [theme]="{'margin-bottom': 0 }"></ngx-skeleton-loader>
          </td>
        </tr>
        <tr *ngIf="!u._isDeleting" class="user-data-row">
          <td>
            <span [ngbTooltip]="'company.users.admin' | translate" [disableTooltip]="!u.isAdministrator"
              [ngClass]="u.isAdministrator ? 'vox-chip vox-chip_royal-blue' : 'vox-chip vox-chip_royal-blue-text'">
              {{u.userId}}
            </span>
          </td>
          <td>{{u.firstName}}</td>
          <td>{{u.lastName}}</td>
          <td>{{u.email}}</td>
          <td class="phone">
            <b *ngIf="!u.phoneNumber">-</b>
            <ul *ngIf="u.phoneNumber">
              <li>{{u.phoneNumber}}</li>
            </ul>
          </td>
          <td>{{u.extension}}</td>
          <td class="user-data-row__actions">
            <div class="user-data-row__actions--wrapper">
              <button class="vox-btn btn btn-warning" [ngbTooltip]="'company.users.info.edit' | translate"
                [disabled]="company.readOnly" (click)="openEditUserPopup(u)">
                <i class="icon-small-edit"></i>
              </button>
              <button class="vox-btn btn btn-warning" *ngIf="u.enabled"
                [ngbTooltip]="'company.users.info.password' | translate" [disabled]="company.readOnly"
                (click)="openSetUserPasswordPopup(u)">
                <i class="icon-small-dial"></i>
              </button>
              <button class="vox-btn btn btn-warning" *ngIf="!u.enabled"
                [ngbTooltip]="'company.users.info.activate' | translate" [disabled]="company.readOnly"
                (click)="openSetUserPasswordPopup(u)">
                <i class="icon-small-check-circle"></i>
              </button>
              <button class="vox-btn btn btn-warning" [ngbTooltip]="'company.users.info.presence' | translate"
                (click)="onClearPresence(u)" [disabled]="company.readOnly">
                <i class="icon-small-telephone"></i>
              </button>
              <button class="vox-btn btn btn-danger" [ngbTooltip]="'company.users.info.delete' | translate"
                (click)="onDeleteUser(u)" [disabled]="u.isAdministrator || company.readOnly">
                <i class="icon-small-delete"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
    <tbody *ngIf="loading">
      <tr *ngFor="let i of [1,2,3,4]">
        <td colspan="7">
          <ngx-skeleton-loader [theme]="{'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="!loading && users.length === 0">
      <tr>
        <td colspan="7" translate>company.users.empty</td>
      </tr>
    </tbody>
  </table>
</div>